import template   from './duration-price.html'
import controller from './duration-price.controller'
import './duration-price.styl'

let component = {
  restrict: 'E',
  bindings: {
    product: '<',
    onDurationChange: '&'
  },
  template,
  controller
}

export default component



// WEBPACK FOOTER //
// ./src/app/pages/vehicle/catalog/components/duration-price/duration-price.component.js